export * from "./LanguageSwitcherMobile";
export { default as LanguageSwitcherDesktop } from "./LanguageSwitcherDesktop";
